export default "__VITE_ASSET__pzqEiHhX__"